import { gql } from '@apollo/client';

export const GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT = gql`
  query ProposalsForHubTableByAccount {
    proposals: proposalsByAccount {
      id
      status
      saleType
      lastName
      fullName
      firstName
      businessName
      proposalStage
      salesPersonName
      createdDateTime
      amountRequested
      vendorOpportunityId
      vendorOpportunity {
        paymentType
        applicationStage
        salesRepresentative {
          firstName
          lastName
          fullName
        }
        financeManager {
          firstName
          lastName
          fullName
        }
        location {
          locationName
        }
        equipments {
          newUsed
        }
      }
    }
  }
`;
